export default class Appear {

	constructor(mc, delay, callback) {
		this.mc = mc;
		this.shown = false;
		this.callback = callback;
		this.delay = Appear.DELAY;
		if (delay != null) {
			this.delay = delay;
		}
	}


	init(){
		if (!this.elementInViewport2()) {
			this.mc.css("opacity", 0);
		} else {
			this.mc.css("opacity", 1);
			this.shown = true;
			if (this.callback != null) {
				this.callback.call(null, this.mc);
			}
		}
		this.id = Appear.COUNTER++;
		jQuery(window).on("scroll.customAppear" + this.id, this.isScrolling.bind(this));
		jQuery(window).on("resize.customAppear2" + this.id, this.isScrolling.bind(this));
	}

	isScrolling() {
		if (!this.shown) {
			if (this.elementInViewport2()) {
				this.shown = true;
				if (this.callback != null) {
					this.callback.call(null, this.mc);
				}
				jQuery(window).off("scroll.customAppear" + this.id);
				jQuery(window).off("resize.customAppear2" + this.id);
				TweenLite.to(this.mc, Appear.ANIMATION_TIME, {
					delay: this.delay,
					css: {
						opacity: 1
					},
					ease: Power2.easeIn
				});
			}
		}
	}

	elementInViewport() {
		var el = this.mc.get(0);
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return (
			top >= window.pageYOffset &&
			left >= window.pageXOffset &&
			(top + height) <= (window.pageYOffset + window.innerHeight) &&
			(left + width) <= (window.pageXOffset + window.innerWidth)
		);
	}

	elementInViewport2() {
		//console.log(this.mc) 
		var el = this.mc.get(0);
		var top = el.offsetTop;
		var left = el.offsetLeft;
		var width = el.offsetWidth;
		var height = el.offsetHeight;

		while (el.offsetParent) {
			el = el.offsetParent;
			top += el.offsetTop;
			left += el.offsetLeft;
		}

		return (
			top < (window.pageYOffset + window.innerHeight) &&
			left < (window.pageXOffset + window.innerWidth) &&
			(top + height) > window.pageYOffset &&
			(left + width) > window.pageXOffset
		);
	}
}
Appear.ANIMATION_TIME = 0.50;
Appear.DELAY = 0;


Appear.COUNTER = 0;